const usersTypes = {
    ALL_USERS: "ALL_USERS",
    CHECKED_IN_USERS: "CHECKED_IN_USERS",
}

export default usersTypes;
